import Button from '@/components/Button'
import FeaturedImage from '@/components/FeaturedImage'

import classNames from 'classnames/bind'
import Link from 'next/link'
import { useState } from 'react'
import styles from './CaseStudyFeed.module.scss'

let cx = classNames.bind(styles)

function CaseStudyFeed({ caseStudies, id }) {
  const [displayCount, setDisplayCount] = useState(12)

  const loadMorePosts = () => {
    setDisplayCount((prevCount) => prevCount + 12)
  }

  const getPreferredImage = (caseStudy) => {
    return caseStudy?.caseStudyFields?.cardImage?.node || caseStudy?.caseStudyFields?.heroImage?.node || null
  }

  return (
    <section {...(id && { id })} className={styles.caseStudies} data-cy="case-studies-container">
      <div className={cx('post-list')}>
        {caseStudies?.slice(0, displayCount).map((caseStudy) => {
          return (
            <div className={cx('container')} key={caseStudy.id ?? ''} id={`post-${caseStudy.id}`} data-cy="case-studies">
              <Link href={caseStudy?.uri ?? '#'} passHref data-cy="case-study-link">
                <div className={cx('card')} data-cy="case-study-card">
                  <FeaturedImage
                    className={caseStudy?.caseStudyFields?.cardImage?.node ? styles.cardImage : styles.heroImage}
                    image={getPreferredImage(caseStudy)}
                    width={540}
                    height={230}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    data-cy="case-study-image"
                  />
                  <div className={styles.headingInfo}>
                    <span className={styles.title} data-cy="case-study-title">
                      {caseStudy.title}
                    </span>
                    <div
                      className={styles.headingTitle}
                      dangerouslySetInnerHTML={{
                        __html: caseStudy.caseStudyFields.title
                      }}
                      data-cy="case-study-heading"
                    ></div>
                  </div>
                </div>
              </Link>
            </div>
          )
        })}
        {caseStudies && caseStudies.length < 1 && <p>No case studies found.</p>}
      </div>
      {caseStudies && displayCount < caseStudies.length && (
        <div className={styles.loadMoreContainer}>
          <Button onClick={loadMorePosts} data-cy="load-more-button">
            Load More
          </Button>
        </div>
      )}
    </section>
  )
}

export default CaseStudyFeed
